var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-sidebar",staticStyle:{"height":"100%"}},[_c('div',{attrs:{"id":"sidebar-scrollbar"}},[_c('nav',{staticClass:"iq-sidebar-menu"},[_c('List',{attrs:{"items":_vm.items,"open":true,"horizontal":_vm.horizontal}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }